module.exports = __webpack_public_path__ + "static/img/pc-web-img-05-01@m.4726c38.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ipark-duty-free/pc-web-img-05-01@m.png
// module id = 7r/i
// module chunks = 0